import $ from 'jquery'
import * as signalR from '@aspnet/signalr';
import * as signalRActions from './actions/signalRActions';
import * as settings from './constants/appsettings.json';

export function signalRStart(store, callback) {

	async function sleep(msec) {
		return new Promise(resolve => setTimeout(resolve, msec));
	}

	async function connect(conn){
		conn.start()
			.then(function () {
				connected(store, conn);
			}).catch( e => {
				sleep(5000);
				connect(conn);  
			}
		)
	}

	const connection = new signalR.HubConnectionBuilder()
		.withUrl(`${settings.SIGNALR_URL}/data`)
		.configureLogging(signalR.LogLevel.Information)
		.build();

	if (connection !== undefined) {	
		connection.on("SetPriceList", (item) => { store.dispatch(signalRActions.SetPriceList(item.priceListId)) });
		connection.on("SetPaymentStatus", (item) => { store.dispatch(signalRActions.SetPaymentStatus(item)) });
		connection.on("SetCardInserted", (item) => { store.dispatch(signalRActions.SetCardInserted(item.cardNumber)) });
		connection.on("AddArticle", (item) => { store.dispatch(signalRActions.AddArticle(item.articleId)) });
		connection.on("SetCustomer", (item) => { store.dispatch(signalRActions.SetCustomer(item)) });
		connection.on("SetArticleWeight", (item) => { store.dispatch(signalRActions.SetArticleWeight(item)) });
		connection.on("SetMessage", (item) => { store.dispatch(signalRActions.SetMessage(item)) });
		connection.on("SetScaleStatus", (item) => { store.dispatch(signalRActions.SetScaleStatus(item)) });
		connection.on("UpdateObjectOverview", (item) => { store.dispatch(signalRActions.UpdateObjectOverview(item)) });
		connection.on("SetTicketValidated", (item) => { store.dispatch(signalRActions.SetTicketValidated(item)) });
		connection.on("SetReservation", (item) => { store.dispatch(signalRActions.SetReservation(item)) });
		connection.on("SetObjectItem", (item) => { store.dispatch(signalRActions.SetObjectItem(item)) });
		connection.on("updatekeyboardlayout", () => { store.dispatch(signalRActions.UpdateKeyboardLayout())});

		connection.onclose(function (e) {
            connect(connection);
		});
		
		connect(connection);
		
		$.connection = connection;
		
		callback();
	} else {
		console.log('no data hub connection!')
	}
}

async function connected(store, connection) {
    // Wait until posDeviceGuid is not null/empty
    let posDeviceGuid = store.getState().generalState.uniqueid;
    while (!posDeviceGuid) {
        await new Promise(resolve => setTimeout(resolve, 100));
        posDeviceGuid = store.getState().generalState.uniqueid;
    }

    if (window.location.hash.startsWith('#/customerdisplay')) {
        posDeviceGuid += '_CUSTOMERDISPLAY';
    }

    await connection.invoke("joinGroup", `POSDEVICEGUID_${posDeviceGuid}`);

    if (store.getState().loginState.loggedin.id > 0) {
        store.dispatch(signalRActions.Login(store.getState().generalState.posId));
    }
}


// WEBPACK FOOTER //
// src/signalr.jsx